import { firstLetter } from '@/lib/initials';

/** A fixed colour per server (the mockup's letter squares), picked from its id so it never moves between visits
 * (a deleted server's card, which has no id, by its name). */
const AVATAR_TONES = [
  'bg-[hsl(4_70%_52%)]', 'bg-[hsl(210_70%_48%)]', 'bg-[hsl(140_50%_38%)]', 'bg-[hsl(220_80%_50%)]',
  'bg-[hsl(28_85%_45%)]', 'bg-[hsl(280_50%_50%)]', 'bg-[hsl(180_60%_32%)]', 'bg-[hsl(340_60%_48%)]',
] as const;
export const avatarTone = (id: string): string => {
  let hash = 0;
  for (const char of id) hash = (hash * 31 + char.charCodeAt(0)) >>> 0;
  return AVATAR_TONES[hash % AVATAR_TONES.length]!;
};

/**
 * The letter of a server's square: its name's first character, whole (an emoji or any astral letter is one code point
 * pair, never split into a lone surrogate), upper-cased the Vietnamese way; "?" for a blank name.
 */
export const serverInitial = (name: string): string => (firstLetter(name.trim()) || '?').toLocaleUpperCase('vi');
